import React from 'react';

// Styles & Assets
import styles from './OptionsAddQuestion.module.css';
import { IoClose } from 'react-icons/io5';
import { ReactComponent as IconAlert } from '../../../assets/icons/Icon-info.svg';

// Components
import ColorSelector from '../../UI/ColorSelector/ColorSelector';

// Interfaces
import { PollAnswer } from '../../../interfaces/Poll';
import { PollQuestionDispatch } from '../../../interfaces/Reducers';

// Language
import { useTranslation } from 'react-i18next';
import Tooltip from '../../UI/Tooltip/Tooltip';

const OptionsAddQuestion: React.FC<{
    answer: PollAnswer,
    hasTable: boolean,
    disableDelete: boolean,
    dispatchQuestion: React.Dispatch<PollQuestionDispatch>
}> = ({ answer, disableDelete, hasTable, dispatchQuestion }) => {

    const { t } = useTranslation();

    const order = answer.order ?? 0;

    const handleInputText = (evt: React.ChangeEvent<HTMLInputElement>) => {
        dispatchQuestion({ type: 'EDIT_ANSWER', payload: { answer: { description: evt.target.value }, uuid: answer.uuid } });
    };

    const handleInputTextTables = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value.trim() === '' ? null : evt.target.value;
        dispatchQuestion({ type: 'SET_TABLE_DESCRIPTION', payload: { table_description: value, uuid: answer.uuid }, });
    };

    const handleInputValue = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const value = evt.target.value.trim() === '' ? undefined : Number(evt.target.value);
        if (!Number.isNaN(value)) dispatchQuestion({ type: 'EDIT_ANSWER', payload: { answer: { value }, uuid: answer.uuid } });
    };

    const deleteOption = (evt: React.FormEvent<HTMLButtonElement>) => {
        evt.preventDefault();
        dispatchQuestion({ type: 'DELETE_ANSWER', payload: answer.uuid });
    };

    const OPTIONS_COLOR_SELECTOR = [
        { id: 0, color: '#fff' },
        { id: 1, color: '#DEFFD7' },
        { id: 2, color: '#effdc7' },
        { id: 3, color: '#FFFAB7' },
        { id: 4, color: '#FFE0AB' },
        { id: 5, color: '#FFD7D7' },
    ];

    const handleClickColor = (id: number) => {
        dispatchQuestion({ type: 'EDIT_ANSWER', payload: { answer: { color_alert: OPTIONS_COLOR_SELECTOR[id].color }, uuid: answer.uuid } });
    };


    return (
        <div className={styles.optionContainer}>
            <button onClick={deleteOption} className={styles.iconContainer} disabled={disableDelete}>
                {disableDelete ?
                    <Tooltip text={t('at_least_two_options_required') as string} customStyles={{ width: '180px' }}>
                        <IoClose className={styles.iconDelete} />
                    </Tooltip>
                    :
                    <IoClose className={styles.iconDelete} />
                }
            </button>
            <div className={styles.textOption}>
                <h3 className={styles.subtitle}>
                    {t('text_option')} {order + 1}  <span style={{ color: 'red' }}>*</span>
                </h3>
                <input onChange={handleInputText} type='text' value={answer.description}></input>
            </div>
            {hasTable &&
                <div className={styles.option}>
                    <div className={styles.titleValueOption}>
                        <h3 className={styles.subtitle}>{t('text_tables')}</h3>
                        <Tooltip
                            text={<span>{t('no_value_message')} <strong>{t('value')}</strong></span>}
                            customStyles={{ width: '180px', fontSize: '0.65rem' }}
                        >
                            <IconAlert style={{ color: '#06f' }} />
                        </Tooltip>
                    </div>
                    <input onChange={handleInputTextTables} type='text' value={answer.table_description || ''}></input>
                </div>
            }
            <div className={styles.valueOption}>
                <div className={styles.titleValueOption}>
                    <h3 className={styles.subtitle}>{t('value')} <span style={{ color: 'red' }}>*</span></h3>
                </div>
                <input
                    onChange={handleInputValue}
                    type='number'
                    defaultValue={answer.value ?? undefined}>
                </input>
            </div>
            {hasTable &&
                <div className={styles.option}>
                    <h3 className={styles.subtitle}>{t('color_table')}</h3>
                    <ColorSelector
                        options={OPTIONS_COLOR_SELECTOR}
                        defaultColor={answer.color_alert || '#fff'}
                        onClick={handleClickColor}
                    />
                </div>
            }
        </div>

    );
};

export default OptionsAddQuestion;